
jQuery(window).resize ->
  # accounts type table, fix all col height
  fixHeight('.___fix-height > div')
  dynamicSwipers()

  return


jQuery(document).ready ($) ->

  block = false


  # accounts type table, fix all col height
  fixHeight('.___fix-height > div')

  # used for mobile to convert in slider
  dynamicSwipers()

  standard4ItemsBreakPoints = {
    0: {
      slidesPerView: 1,
    },
    700: {
      slidesPerView: 2,
    },
    1000: {
      slidesPerView: 3,
    },
    1300: {
      slidesPerView: 4,
    }
  }



  setSwiper '___partnership-benefits', 5, 0, 25, true, false, true, {
    0: {
      slidesPerView: 1,
    },
    550: {
      slidesPerView: 2,
    },
    700: {
      slidesPerView: 3,
    },
    900: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 5,
    }
  }

  autoSwipper = setSwiper '___swiper-auto'
  setSwiper '___swiper', 1, autoSwipper
  setSwiper '___swiper-4-items', 4, 0, 50, false, false, true, standard4ItemsBreakPoints
  advantagesSwiper = setSwiper '___swiper-trading-advantages .key-points', 3, 0, 0, false, true, true, {
    0: {
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 25
    },
    500: {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 25
    },
    700: {
      slidesPerView: 3,
      centeredSlides: true,
      spaceBetween: 0
    }
  }
  if $('.___swiper-trading-advantages').length > 0
    advantagesSwiper.slideTo(1)

  setSwiper '___trading-connection', 4, 0, 50, false, false, true, standard4ItemsBreakPoints

  setSwiper '___swiper-5-items', 5, 0, 50, false, false, true, {
    0: {
      slidesPerView: 2,
    },
    800: {
      slidesPerView: 4,
    },
    1150: {
      slidesPerView: 5,
    }
  }
  setSwiper '___awards_footer', 3, 0, 0, true, false, true, {
    0: {
      slidesPerView: 1,
    },
    500: {
      slidesPerView: 2,
    },
    1000: {
      slidesPerView: 3,
    }
  }

  setSwiper 'instruments-menu.home.___swiper-auto', 3, 0, 25, true, false, true, {
    0: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    700: {
      slidesPerView: 3,
    },
    940: {
      slidesPerView: 4,
    },
    1250: {
      slidesPerView: 3,
    }
  }

  setSwiper '__accounts-page .instruments-menu', 5, 0, 25, true, false, true, {
    0: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    700: {
      slidesPerView: 3,
    },
    940: {
      slidesPerView: 4,
    },
    1250: {
      slidesPerView: 5,
    }
  }

  setSwiper '___swiper-header-regulations', 3, 0, 25, false, false, false, {
    0: {
      slidesPerView: 1,
    },
    700: {
      slidesPerView: 2,
    },
    1000: {
      slidesPerView: 3,
    }
  }

  setSwiperHome '___swiper-slider', 1, 0, 0, true, false, true

  # instruments navigation
  instrumentsSwipper = setSwiper '___swiper-instruments.___swiper-auto'


  marketType = getUrlParameter('category')
  if window.marketsAllowedSlugs and window.marketsAllowedSlugs.includes(marketType)
    offset = $('.___swiper-instruments').offset()
    $('html, body').animate({
      scrollTop: offset.top - 125
    }, 1000)
    index = $('.___selected_index').data('selected-index')
    instrumentsSwipper.slideTo(index)

  instrumentsSwipper.on 'click', ->
    $('.___swiper-instruments .swiper-slide').removeClass('wiper-slide-active swiper-slide-thumb-active')
    slug = $(instrumentsSwipper.clickedSlide).data('parent-slug')
    $(instrumentsSwipper.clickedSlide).addClass('wiper-slide-active swiper-slide-thumb-active')

    $('.markets-info').hide()
    $('.__markets-' + slug + '__').show()
    $('.__market_table__.' + slug).DataTable().columns.adjust().responsive.recalc()
    return

  # accounts type
  if $('.___swiper-accounts-type').length > 0
    accountsSwipper = setSwiper '___swiper-accounts-type', 3, 0, 0, true, false, true, {
      0: {
        slidesPerView: 1,
      },
      700: {
        slidesPerView: 2,
      },
      1000: {
        slidesPerView: 3,
      }
    }

    accountType = getUrlParameter('account')
    accountsSwipper.slideTo(1)
    if window.accountsAllowedSlugs and window.accountsAllowedSlugs.includes(accountType)
      accountIndex = $('.___swiper-accounts-type .swiper-slide.' + accountType).data('index')
      $('.___swiper-accounts-type .swiper-slide').removeClass('wiper-slide-active swiper-slide-thumb-active')
      $('.___swiper-accounts-type .swiper-slide.' + accountType).addClass('wiper-slide-active swiper-slide-thumb-active')

      offset = $('.account-types-comparison-table').offset()
      $('html, body').animate({
        scrollTop: offset.top - 75
      }, 1000)

      accountsSwipper.slideTo(accountIndex)

    accountsSwipper.on 'click', ->
      accountIndex = $(accountsSwipper.clickedSlide).data('index')
      slug = $(accountsSwipper.clickedSlide).data('slug')
      $('.___swiper-accounts-type .swiper-slide').removeClass('wiper-slide-active swiper-slide-thumb-active')
      $(accountsSwipper.clickedSlide).addClass('wiper-slide-active swiper-slide-thumb-active')
      accountsSwipper.slideTo(accountIndex)
      $('.account-extra-info').hide()
      $('.__account-table-extra-info-' + slug + '__').show()
      return



  return


window.setSwiper = (selector, slidesPerView, thumbsSwipper, spaceBetween, pagination, centeredSlides, autoplay, breakpoints, centerInsufficientSlides) ->
  if slidesPerView == undefined
    slidesPerView = 'auto'

  if centerInsufficientSlides == undefined
    centerInsufficientSlides = true

  if spaceBetween == undefined
    spaceBetween = 0

  if centeredSlides == undefined or !centeredSlides
    centeredSlides = false
  else
    centeredSlides = true

  if autoplay == undefined
    autoplay = false
  else
    autoplay = {
      pauseOnMouseEnter: true
      disableOnInteraction: true
    }

  if pagination == undefined
    pagination = false
  else
    pagination = {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }


  swiper = new Swiper('.' + selector, {
    direction: 'horizontal'
    loop: false
    centerInsufficientSlides: centerInsufficientSlides
    centeredSlides: centeredSlides
    autoplay: autoplay
    slidesPerView: slidesPerView
    spaceBetween: spaceBetween
    observer: true
    observeParents: true
    pagination: pagination
    thumbs: {
      swiper: thumbsSwipper
    }
    breakpoints: breakpoints
  })

  return swiper

window.setSwiperHome = (selector, slidesPerView, thumbsSwipper, spaceBetween, pagination, centeredSlides, autoplay, breakpoints, centerInsufficientSlides) ->
  if slidesPerView == undefined
    slidesPerView = 'auto'

  if centerInsufficientSlides == undefined
    centerInsufficientSlides = true

  if spaceBetween == undefined
    spaceBetween = 0

  if centeredSlides == undefined or !centeredSlides
    centeredSlides = false
  else
    centeredSlides = true

  if autoplay == undefined
    autoplay = false
  else
    autoplay = {
      pauseOnMouseEnter: true
      disableOnInteraction: true
    }

  if pagination == undefined
    pagination = false
  else
    pagination = {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }

  # https://swiperjs.com/swiper-api#autoplay
  swiper = new Swiper('.' + selector, {
    direction: 'horizontal'
    loop: false
    centerInsufficientSlides: centerInsufficientSlides
    centeredSlides: centeredSlides
    autoplay: {
      delay: 10000
      disableOnInteraction: false
      pauseOnMouseEnter: false
    }
    slidesPerView: slidesPerView
    spaceBetween: spaceBetween
    speed: 1000
    observer: true
    observeParents: true
    pagination: pagination
    thumbs: {
      swiper: thumbsSwipper
    }
    breakpoints: breakpoints
  })


  return swiper

swiperMobile3Items = undefined
swiperMobile2Items = undefined
swiperMobile5Items = undefined
swiperMobileCirclesItems = undefined
swiperMobileHexagonItems = undefined
swiperInnerSubMenuItems = undefined
swiperCategoriesMenuItems = undefined
swiperHomeCirlesItems = undefined


window.dynamicSwipers = () ->
  swiperInnerSubMenuItems = setSwiperOnResize('___swiper-mobile-inner-sub-menu-items', 1101, swiperInnerSubMenuItems, {
    0: {
      slidesPerView: 'auto',
    }
  }, 25, 'auto', undefined )

  swiperCategoriesMenuItems = setSwiperOnResize('___swiper-mobile-categories-items', 1301, swiperCategoriesMenuItems, {
    0: {
      slidesPerView: 'auto',
    }
  }, 25, 'auto', undefined )

  swiperMobileHexagonItems = setSwiperOnResize('___swiper-mobile-hexagon-items', 1001, swiperMobileHexagonItems, {
    0: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    850: {
      slidesPerView: 3,
    }
  })

  swiperMobileCirclesItems = setSwiperOnResize('___swiper-mobile-circle-items', 701, swiperMobileCirclesItems, {
    0: {
      slidesPerView: 1,
    },
    500: {
      slidesPerView: 2,
    }
  })

  swiperMobile3Items = setSwiperOnResize('___swiper-mobile-3-items', 1001, swiperMobile3Items, {
    0: {
      slidesPerView: 1,
    },
    700: {
      slidesPerView: 2,
    },
    800: {
      slidesPerView: 3,
    }
  })

  swiperMobile2Items = setSwiperOnResize('___swiper-mobile-2-items', 1001, swiperMobile2Items, {
    0: {
      slidesPerView: 1,
    },
    800: {
      slidesPerView: 2,
    }
  })

  swiperMobile5Items = setSwiperOnResize('___swiper-mobile-5-items', 1001, swiperMobile5Items, {
    0: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    750: {
      slidesPerView: 3,
    },
    800: {
      slidesPerView: 4,
    }
  }, 25)

  swiperHomeCirlesItems = setSwiperOnResize '___swiper-circles-flex-home', 701, swiperHomeCirlesItems, {
    0: {
      slidesPerView: 1,
    },
    500: {
      slidesPerView: 2,
    },
    750: {
      slidesPerView: 3,
    }
  }


  return

window.setSwiperOnResize = (selector, maxWidth, swiperInstance, breakPoints, spaceBetween, slidesPerView, autoPlay) ->
  if(selector.length > 0)
    if spaceBetween == undefined
      spaceBetween = 50
    if slidesPerView == undefined
      slidesPerView = 3
    if autoPlay != undefined
      autoPlay = true

    if window.innerWidth < maxWidth
      if typeof swiperInstance == 'undefined'
        jQuery('.' + selector).removeClass('swiper-container-replace').addClass('swiper-container')
        jQuery('.' + selector).find('.swiper-wrapper-replace').removeClass('swiper-wrapper-replace').addClass('swiper-wrapper')
        jQuery('.' + selector).find('.swiper-slide-replace').removeClass('swiper-slide-replace').addClass('swiper-slide')
        jQuery('.' + selector).find('li').addClass('swiper-slide')
        swiperInstance = setSwiper selector, slidesPerView, 0, spaceBetween, true, false, autoPlay, breakPoints
    else
      try
        swiperInstance.destroy()

      jQuery('.swiper-wrapper').removeAttr('style')
      jQuery('.swiper-slide').removeAttr('style')
      jQuery('.' + selector).removeClass('swiper-container').addClass('swiper-container-replace')
      jQuery('.' + selector).find('.swiper-wrapper').removeClass('swiper-wrapper').addClass('swiper-wrapper-replace')
      jQuery('.' + selector).find('.swiper-slide').removeClass('swiper-slide').addClass('swiper-slide-replace')
      jQuery('.' + selector).find('li').removeClass('swiper-slide')
      swiperInstance = undefined
    return swiperInstance
